import { defineComponent as _defineComponent } from 'vue'
import { SpinningBlock } from '@/features/sports/components/spinning-texts';


export default /*#__PURE__*/_defineComponent({
  __name: 'SportSpinningText',
  props: {
    spinningText: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})